import { z } from "zod";
export const updatePlunkIntegrationSchema = z.object({
    api_key: z.string().min(1),
    from_email: z.email().toLowerCase().trim(),
});
